/* Ora Frames — Milestone Frame and Couple Names Frame customizer.
   Drives window.OraTextPoster (ora-textposter-engine.js) and adds the design to the cart,
   with every setting saved on the order so the print file can be rebuilt exactly. */
(function () {
  'use strict';

  var SIZES = {
    A4: { label: 'A4', cm: '21 × 29.7 cm' },
    A3: { label: 'A3', cm: '29.7 × 42 cm' },
    A2: { label: 'A2', cm: '42 × 59.4 cm' }
  };

  function sizeKey(title) { if (/digital/i.test(title || '')) return 'A2'; var m = /\bA[2-4]\b/i.exec(title || ''); return m ? m[0].toUpperCase() : 'A2'; }

  function moneyFormatter(format) {
    format = format || ('{' + '{amount}' + '}');
    return function (cents) {
      var whole = Math.floor(cents / 100), frac = String(cents % 100).padStart(2, '0');
      var grouped = function (sep) { return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return grouped(',');
        if (k === 'amount_with_comma_separator') return grouped('.') + (frac === '00' ? '' : ',' + frac);
        if (k === 'amount_no_decimals_with_comma_separator') return grouped('.');
        return grouped(',') + (frac === '00' ? '' : '.' + frac);
      });
    };
  }

  function encodeChunks(data) {
    var raw = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
    var chunks = {};
    (raw.match(/.{1,245}/g) || []).forEach(function (chunk, i) { chunks['_poster_data' + (i === 0 ? '' : '_' + i)] = chunk; });
    return chunks;
  }

  // Digital-file variant: no frame, delivered as a print-ready file on WhatsApp or email
  function isDigital(state) { return !!(state.variant && /digital/i.test(state.variant.title)); }
  function markDigital(properties) {
    properties['Frame'] = 'None (digital file)';
    properties['Format'] = 'Digital file (print-ready, sent on WhatsApp or email)';
    properties['_frame'] = 'none';
    properties['_format'] = 'digital';
  }

  // "Share this design": a link that opens this designer with the same design (read by applyPreset)
  function shareDesign(state, btn) {
    var s = {};
    Object.keys(state).forEach(function (k) {
      var v = state[k];
      if (k === 'variant' || k === 'kind' || v === null || typeof v === 'object' || typeof v === 'function') return;
      s[k] = v;
    });
    var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(s)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    var url = window.location.origin + window.location.pathname + '?design=' + b64;
    var text = (btn && btn.dataset.shareText) || '';
    if (navigator.share) {
      navigator.share({ title: document.title, text: text, url: url }).catch(function () {});
    } else {
      window.open('https://wa.me/?text=' + encodeURIComponent((text ? text + ' ' : '') + url), '_blank', 'noopener');
    }
  }

  // "Start with this design" links (gift guide pages): ?design=<base64url JSON> fills the designer in.
  // Only settings this designer has are taken, choices must match one of its options, text is capped.
  function applyPreset(state, form) {
    var raw = new URLSearchParams(window.location.search).get('design');
    if (!raw) return false;
    var d;
    try { d = JSON.parse(decodeURIComponent(escape(atob(raw.replace(/-/g, '+').replace(/_/g, '/'))))); } catch (e) { return false; }
    if (!d || typeof d !== 'object') return false;
    var used = false;
    Object.keys(d).forEach(function (k) {
      if (k === 'variant' || k === 'kind' || !Object.prototype.hasOwnProperty.call(state, k)) return;
      var cur = state[k], v = d[k], field = form.elements[k];
      if (field && (field.type === 'radio' || field.tagName === 'SELECT' || (field.length && field[0] && field[0].type === 'radio'))) {
        var ok = Array.prototype.some.call(field.length !== undefined && field.tagName !== 'SELECT' ? field : (field.options || [field]), function (o) { return o.value === String(v); });
        if (!ok) return;
        v = String(v);
      } else if (typeof cur === 'number') {
        v = parseFloat(v); if (!isFinite(v)) return;
      } else if (typeof cur === 'boolean') {
        v = !!v;
      } else if (typeof cur === 'string') {
        if (typeof v !== 'string' && typeof v !== 'number') return;
        v = String(v).slice(0, field && field.maxLength > 0 ? field.maxLength : 120);
        if (k === 'accentColor' && v && !/^#[0-9a-f]{6}$/i.test(v)) return;
        if ((k === 'date') && v && !/^\d{4}-\d{2}-\d{2}$/.test(v)) return;
        if ((k === 'time') && v && !/^\d{2}:\d{2}$/.test(v)) return;
      } else return;
      state[k] = v; used = true;
    });
    return used;
  }

  function init(root) {
    var T = window.OraTextPoster;
    var kind = root.dataset.kind === 'names' ? 'names' : 'milestone';
    var form = root.querySelector('[data-tp-form]');
    var canvas = root.querySelector('[data-tp-canvas]');
    var wrap = root.querySelector('[data-tp-wrap]');
    var frameEl = root.querySelector('[data-tp-frame]');
    var variants = JSON.parse(root.querySelector('[data-tp-variants]').textContent);
    var strings = JSON.parse(root.querySelector('[data-tp-strings]').textContent);
    var defaults = JSON.parse(root.querySelector('[data-tp-defaults]').textContent);
    var money = moneyFormatter(root.dataset.moneyFormat);
    // Price: the original price struck through when the variant is discounted (compare-at price), and a "Save" tag
    function priceHtml(v, noSave) {
      if (!(v.compare_at_price > v.price)) return money(v.price);
      var html = '<s class="ora-was">' + money(v.compare_at_price) + '</s> ' + money(v.price);
      return noSave ? html : html + ' <span class="ora-save">' + escapeHtml(strings.save || 'Save') + ' ' + money(v.compare_at_price - v.price) + '</span>';
    }
    // The "Digital file: ~~Rs 990~~ Rs 470" offer under the price: only while a framed size is selected
    function syncOffer() {
      var offer = root.querySelector('[data-digital-offer]');
      if (offer) offer.hidden = !state.variant || state.variant.requires_shipping === false;
    }
    function escapeHtml(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    var params = new URLSearchParams(window.location.search);
    var state = Object.assign({
      kind: kind,
      background: 'ivory', accentColor: '', nameFont: 'Great Vibes', numberFont: 'Cormorant Garamond', frameColor: 'black',
      showNumber: true, showHeadline: true, showName: true, showDetails: true, showMessage: true,
      showJoiner: true, showLine: true, showPlace: true
    }, defaults, {
      variant: variants.find(function (v) { return String(v.id) === params.get('variant'); }) || null
    });

    // ---------- preview ----------
    var pending = false;
    function draw() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var w = Math.min(700, Math.round((wrap.clientWidth || 500) * (window.devicePixelRatio || 1))); // preview only: too small to print from
        var h = Math.round(w * T.PAGE_H / T.PAGE_W);
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
        T.draw(canvas, state);
      });
    }
    if (window.ResizeObserver) new ResizeObserver(draw).observe(wrap);

    function drawOrnaments() {
      root.querySelectorAll('[data-tp-ornament]').forEach(function (c) { T.drawOrnament(c, c.dataset.tpOrnament, '#7A5C32'); });
    }

    // ---------- form <-> state ----------
    function syncForm() {
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || !(el.name in state)) return;
        var v = state[el.name];
        if (el.type === 'radio') el.checked = (el.value === String(v));
        else if (el.type !== 'checkbox' && el.value !== v) el.value = v == null ? '' : v;
      });
      form.querySelectorAll('input[name="variant"]').forEach(function (r) { r.checked = !!state.variant && String(state.variant.id) === r.value; });
      root.querySelectorAll('[data-tp-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', state[b.dataset.tpToggle] ? 'true' : 'false'); });
      updateLabels();
    }

    function updateLabels() {
      root.querySelectorAll('[data-tp-label]').forEach(function (el) {
        var key = el.dataset.tpLabel;
        var input = form.querySelector('input[name="' + key + '"][value="' + state[key] + '"]');
        el.textContent = input ? (input.dataset.label || input.value) : '';
      });
      root.querySelectorAll('[data-tp-count]').forEach(function (el) { el.textContent = (state[el.dataset.tpCount] || '').length + ' / 90'; });
      var priceEl = root.querySelector('[data-tp-price]'), titleEl = root.querySelector('[data-tp-variant-title]'), btnEl = root.querySelector('[data-tp-btn-label]');
      if (state.variant) {
        priceEl.innerHTML = priceHtml(state.variant); syncOffer();
        titleEl.textContent = '· ' + state.variant.title;
        btnEl.innerHTML = escapeHtml(strings.addLabel) + ' · ' + priceHtml(state.variant, true);
      } else {
        priceEl.innerHTML = strings.fromPrice; syncOffer(); titleEl.textContent = ''; btnEl.textContent = strings.chooseSize;
      }
      var s = SIZES[state.variant ? sizeKey(state.variant.title) : 'A2'];
      frameEl.className = 'ora-frame ora-sm__frame ora-frame--' + state.frameColor;
      if (isDigital(state)) frameEl.className = 'ora-frame ora-sm__frame ora-frame--none';
      root.classList.toggle('is-digital', isDigital(state));
      frameEl.dataset.size = s.label;
      var note = root.querySelector('[data-tp-size-note]');
      if (note) note.textContent = 'Shown at ' + s.label + ' · ' + s.cm;
    }

    function onChange(e) {
      var el = e.target;
      if (!el.name) return;
      if (el.name === 'variant') {
        state.variant = variants.find(function (v) { return String(v.id) === el.value; }) || state.variant;
        root.querySelector('[data-tp-sizes]').classList.remove('is-attention');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', state.variant.id);
        window.history.replaceState({}, '', url.toString());
      } else if (el.name in state) {
        state[el.name] = el.value;
      }
      hideError(); updateLabels(); draw();
      // A newly picked lettering downloads now; redraw once it's ready
      if (el.name === 'nameFont' || el.name === 'numberFont') T.loadFonts(state).then(draw);
    }
    form.addEventListener('input', onChange);
    form.addEventListener('change', onChange);

    root.querySelectorAll('[data-tp-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.tpToggle;
        state[key] = !state[key];
        b.setAttribute('aria-pressed', state[key] ? 'true' : 'false');
        draw();
      });
    });

    var picker = root.querySelector('[data-tp-accent-picker]');
    if (picker) picker.addEventListener('input', function () {
      state.accentColor = picker.value;
      form.querySelectorAll('input[name="accentColor"]').forEach(function (r) { r.checked = false; });
      draw();
    });

    // ---------- add to cart ----------
    var errorEl = root.querySelector('[data-tp-error]');
    function showError(m) { errorEl.textContent = m; errorEl.hidden = false; }
    function hideError() { errorEl.hidden = true; }
    var loader = root.querySelector('[data-tp-loader]');
    window.addEventListener('pageshow', function (e) { if (e.persisted) loader.hidden = true; });

    function hasText() {
      if (kind === 'names') return !!(state.name1 || state.name2 || (state.showLine && state.line));
      return !!((state.showNumber && state.number) || (state.showHeadline && state.headline) || (state.showName && state.name));
    }

    function visibleProperties() {
      var bg = (T.BACKGROUNDS[state.background] || {}).label || state.background;
      var top = T.HEADERS[state.header] || state.header;
      var frame = { black: 'Black', white: 'White' }[state.frameColor] || state.frameColor;
      var p;
      if (kind === 'names') {
        p = {
          'Names': [state.name1, state.showJoiner ? state.joiner : '', state.name2].filter(Boolean).join(' '),
          'Line': state.showLine ? state.line : '',
          'Place': state.showPlace ? state.place : ''
        };
      } else {
        p = {
          'Number': state.showNumber ? state.number : '',
          'Headline': state.showHeadline ? state.headline : '',
          'Name': state.showName ? state.name : '',
          'Date and place': state.showDetails ? state.details : '',
          'Message': state.showMessage ? state.message : ''
        };
      }
      p['Top design'] = top;
      p['Background'] = bg;
      p['Lettering'] = (T.NAME_FONTS[state.nameFont] || {}).label || state.nameFont;
      p['Frame'] = frame;
      return p;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideError();
      if (!hasText()) { showError(strings.needText); return; }
      if (!state.variant) {
        var sizes = root.querySelector('[data-tp-sizes]');
        showError(strings.needSize);
        sizes.classList.add('is-attention');
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = sizes.querySelector('input:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
        return;
      }
      loader.hidden = false;
      var size = sizeKey(state.variant.title);
      var design = Object.assign({}, state, { size: size, variantId: state.variant.id, version: 1, release: '2026.11.01', generatedAt: new Date().toISOString() });
      delete design.variant;
      var properties = Object.assign(visibleProperties(), {
        '_poster_type': kind,
        '_size': size,
        '_frame': state.frameColor,
        '_variant_id': String(state.variant.id),
        '_generated_at': design.generatedAt
      }, encodeChunks(design));
      // Snapshot of this design for the cart (kept in the customer's browser only)
      var designId = window.OraDesignThumb ? window.OraDesignThumb.save(canvas) : '';
      if (designId) properties['_design_id'] = designId;
      if (isDigital(state)) markDigital(properties);
      Object.keys(properties).forEach(function (k) { if (properties[k] === '' || properties[k] == null) delete properties[k]; });

      fetch(root.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: state.variant.id, quantity: 1, properties: properties }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || strings.cartError);
          window.location.href = root.dataset.cartUrl;
        })
        .catch(function (err) { loader.hidden = true; showError(err.message || strings.cartError); });
    });

    applyPreset(state, form);
    var shareBtn = root.querySelector('[data-share-design]');
    if (shareBtn) shareBtn.addEventListener('click', function () { shareDesign(state, shareBtn); });
    // ---------- start ----------
    syncForm();
    T.loadFonts(state).then(function () { drawOrnaments(); draw(); });
    draw();
    root.oraTextPoster = { state: state, draw: draw, kind: kind };
  }

  function boot() {
    if (!window.OraTextPoster) return setTimeout(boot, 50);
    document.querySelectorAll('[data-ora-textposter]').forEach(function (root) { if (!root.oraTextPoster) init(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
